import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import defaultImg from '@/assets/images/defaultImg.png'
export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        
        vuex_default_img: defaultImg, // 默认图
        vuex_token: '',
        vuex_userId: '',
        vuex_isLogin: false, // 是否登录

        vuex_relevance_company: 0, // 关联公司的状态：1.已提交、审核中，2.已关联，3.已驳回，0.未关联公司

        vuex_cartWin: false, // 购物车弹窗

        vuex_userInfo: {}, // 用户信息

        vuex_quick_win: false, // 快速浏览弹窗
        vuex_quick_id: '', // 快速浏览弹窗的产品id

        vuex_cart_skip_type: '', // 购物车跳转结算页的状态，1：去支付

        vuex_compare_popup_list: [], // 比较弹窗里的商品
        vuex_compare_popup_list_detail: [], // 产品详情页进入比较页要比较的商品

        header_search_history: [], // 顶部历史搜索记录

        vuex_yhqId: '', // 购物车跳转结算使用的优惠券id
    },
    getters: {
        vuex_h5: () => {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        }
    },
    mutations: {
        set_vuex_data(state, opt) {
            let { k, v } = opt
            state[k] = v
        },
    },
    actions: {},
    modules: {},
})
